<template>
  <footer class="main-footer d-flex p-2 px-3 bg-white border-top">
    <div :class="[contained ? 'container' : 'container-fluid']">
      <div class="row">
        <ul class="nav">
          <li v-for="(item, idx) in menuItems" :key="idx" class="nav-item">
            <d-link class="nav-link" :to="item.to">{{ item.title }}</d-link>
          </li>
        </ul>
        <span class="copyright ml-auto my-auto mr-2">{{ copyright }}</span>
        <div class="changelog"></div>
      </div>
    </div>
  </footer>
</template>

<script>
const defaultMenuItems = [
  {
    title: "About",
    to: "https://www.givemagic.co/"
  },
  {
    title: "Download Storytelling App",
    to: "/download"
  },
  {
    title: "Affiliate Program",
    to: "#"
  },
  {
    title: "Contact Us",
    to: "#"
  },
  {
    title: "Privacy Policy",
    to: "/billing"
  },
  {
    title: "Community Guidelines",
    to: "#"
  }
];

export default {
  name: "main-footer",
  props: {
    /**
     * The footer menu items.
     */
    menuItems: {
      type: Array,
      default() {
        return defaultMenuItems;
      }
    },
    /**
     * The copyright information.
     */
    copyright: {
      type: String,
      default: "Copyright © 2020 Givemagic"
    },
    /**
     * Whether the footer should be wrapped in a container, or not.
     */
    contained: {
      type: Boolean,
      default: false
    }
  }
};
</script>
